import type { Language } from '../types';
import { getTranslation } from './translations';

const COUNTRY_ALIASES: Readonly<Record<string, string>> = {
    israel: 'country_israel',
    'united states': 'country_united_states',
    usa: 'country_united_states',
    us: 'country_united_states',
    'united kingdom': 'country_united_kingdom',
    uk: 'country_united_kingdom',
    england: 'country_united_kingdom',
    france: 'country_france',
    italy: 'country_italy',
    spain: 'country_spain',
    germany: 'country_germany',
    mexico: 'country_mexico',
    morocco: 'country_morocco',
    turkey: 'country_turkey',
    lebanon: 'country_lebanon',
    greece: 'country_greece',
    japan: 'country_japan',
    china: 'country_china',
    india: 'country_india',
    thailand: 'country_thailand',
    brazil: 'country_brazil',
    argentina: 'country_argentina',
    canada: 'country_canada',
    australia: 'country_australia',
    netherlands: 'country_netherlands',
    belgium: 'country_belgium',
    switzerland: 'country_switzerland',
    austria: 'country_austria',
    portugal: 'country_portugal',
    poland: 'country_poland',
    egypt: 'country_egypt',
    'south korea': 'country_south_korea',
    korea: 'country_south_korea',
    vietnam: 'country_vietnam',
    iran: 'country_iran',
    syria: 'country_syria',
    jordan: 'country_jordan',
    palestine: 'country_palestine',
    tunisia: 'country_tunisia',
    ethiopia: 'country_ethiopia',
    iraq: 'country_iraq',
    yemen: 'country_yemen',
    russia: 'country_russia',
    ukraine: 'country_ukraine',
};

const HEBREW_COUNTRY_ALIASES: Readonly<Record<string, string>> = {
    'ישראל': 'country_israel',
    'ארה"ב': 'country_united_states',
    'ארצות הברית': 'country_united_states',
    'בריטניה': 'country_united_kingdom',
    'צרפת': 'country_france',
    'איטליה': 'country_italy',
    'ספרד': 'country_spain',
    'גרמניה': 'country_germany',
    'מקסיקו': 'country_mexico',
    'מרוקו': 'country_morocco',
    'טורקיה': 'country_turkey',
    'לבנון': 'country_lebanon',
    'יוון': 'country_greece',
    'יפן': 'country_japan',
    'סין': 'country_china',
    'הודו': 'country_india',
    'תאילנד': 'country_thailand',
    'ברזיל': 'country_brazil',
    'ארגנטינה': 'country_argentina',
    'קנדה': 'country_canada',
};

function normalizeCountryKey(country: string): string {
    return country
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

function resolveCountryTranslationKey(country: string): string | null {
    const trimmed = country.trim();
    if (!trimmed) return null;

    const hebrewKey = HEBREW_COUNTRY_ALIASES[trimmed];
    if (hebrewKey) return hebrewKey;

    const normalized = normalizeCountryKey(trimmed);
    return COUNTRY_ALIASES[normalized] ?? null;
}

/** Returns a localized country name, falling back to English then the stored value. */
export function getCountryDisplayName(country: string | undefined, language?: Language): string {
    const trimmed = country?.trim();
    if (!trimmed) return '';

    const translationKey = resolveCountryTranslationKey(trimmed);
    if (!translationKey) return trimmed;

    return getTranslation(language, translationKey);
}
